(() => {
  class ProductGallery extends HTMLElement {
    constructor() {
      super();

      this._attrs = {
        item: "data-product-gallery-item",
        thumb: "data-product-gallery-thumb",
        slider: "data-product-gallery-slider",
        lightbox: "data-product-gallery-lightbox",
        wrapper: "data-product-gallery-wrapper",
        close: "data-product-gallery-close",
      };
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.$lightbox = document.querySelector(`[${this._attrs.lightbox}]`);
      this.addEventListener("click", this.onClick.bind(this));
    }

    onClick(evt) {
      this.handleDesktopLightbox(evt);
      this.handleMobileLightbox(evt);
      this.handleClose(evt);
      this.handleThumb(evt);
    }

    handleMobileLightbox(evt) {
      const $el = evt.target.closest(`[${this._attrs.item}]`);

      if (!$el) return;
      if ($el.closest(`[${this._attrs.lightbox}]`)) return;
      if (!$el.hasAttribute(this._attrs.slider)) return;

      const $wrapper = $el.closest(`[${this._attrs.wrapper}]`);
      const activeSlideIndex = $el.getAttribute(this._attrs.slider)

      if (!$wrapper) return;

      const $cloned = $wrapper.cloneNode(true);
      const $swiper = $cloned.querySelector("swiper-container");
      const paginationEl = $swiper.getAttribute("pagination-el");
      const $pagination = $cloned.querySelector(paginationEl);

      $swiper.setAttribute("initial-slide", activeSlideIndex)
      $swiper.setAttribute("slides-per-view", 1);
      $swiper.setAttribute("space-between", 0);
      $swiper.setAttribute("pagination-el", `${paginationEl}-lightbox`);
      $pagination.setAttribute(
        "id",
        `${paginationEl.replace("#", "")}-lightbox`
      );

      this.constructModal($cloned, $el.getAttribute(this._attrs.item));
    }

    handleThumb(evt) {
      const $el = evt.target.closest(`[${this._attrs.thumb}]`);

      if (!$el) return;

      const position = $el.getAttribute(this._attrs.thumb);

      this.scrollToActiveItem(position);
    }

    handleClose(evt) {
      const $el = evt.target.closest(`[${this._attrs.close}]`);

      if (!$el) return;

      this.toggleLightbox(false);
    }

    handleDesktopLightbox(evt) {
      const $el = evt.target.closest(`[${this._attrs.item}]`);

      if (!$el) return;
      if ($el.closest(`[${this._attrs.lightbox}]`)) return;
      if ($el.hasAttribute(this._attrs.slider)) return;

      const $wrapper = $el.closest(`[${this._attrs.wrapper}]`);

      if (!$wrapper) return;

      this.constructModal(
        $wrapper.cloneNode(true),
        $el.getAttribute(this._attrs.item)
      );
      this.observeItems();
    }

    observeItems() {
      this.$lightboxItemObserver && this.$lightboxItemObserver.disconnect();
      this.$lightboxItemObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio > 0.4) {
              this.selectActiveThumb(
                entry.target.getAttribute(this._attrs.item)
              );
            }
          });
        },
        {
          threshold: [0.4],
        }
      )

      this.$lightbox
        .querySelectorAll(`[${this._attrs.item}]`)
        .forEach(($item) => this.$lightboxItemObserver.observe($item));
    }

    constructModal($el, position) {
      this.$lightbox.innerHTML = "";

      this.$lightbox.appendChild($el);

      this.scrollToActiveItem(position);

      this.toggleLightbox(true);
    }

    scrollToActiveItem(position) {
      this.$lightbox
        .querySelector(`[${this._attrs.item}="${position}"]`)
        .scrollIntoView();
      this.selectActiveThumb(position);
    }

    selectActiveThumb(position) {
      this.$lightbox
        .querySelectorAll(`[${this._attrs.thumb}]`)
        .forEach(($thumb) => {
          if ($thumb.getAttribute(this._attrs.thumb) == position) {
            $thumb.classList.add("active");
            $thumb.scrollIntoView();
          } else {
            $thumb.classList.remove("active");
          }
        });
    }

    toggleLightbox(open = false) {
      this.$lightbox.parentElement.classList.toggle("show", open);
      document.body.classList.toggle("overflow-hidden", open);
    }
  }

  customElements.define("product-gallery", ProductGallery);
})();
